
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      contact: {
        email: 's-sumita [at] g.ecc.u-tokyo.ac.jp',
        tel: '03-5454-6541',
        fax: '',
        address: `〒153-8902 東京都目黒区駒場3-8-1
        東京大学 大学院総合文化研究科
        広域科学専攻 相関基礎科学系
        16号館2階201B号室`,
        googlemap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.6961009265906!2d139.68245595090497!3d35.65985833865393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f3510abfcf29%3A0x447d943f8a75b1f8!2z5p2x5Lqs5aSn5a2m6aeS5aC044Kt44Oj44Oz44OR44K5!5e0!3m2!1sja!2sjp!4v1661758483962!5m2!1sja!2sjp',
        mapnote: '<a href="https://www.c.u-tokyo.ac.jp/info/about/visitors/maps-directions/campusmap.html" target="_blank">駒場Iキャンパスマップ</a>'
      }
    }
  }
})
